var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('JoLoadMore',{key:"find-rec",ref:"loadmore",on:{"onRefresh":_vm.onRefresh,"onLoadMore":_vm.onLoadMore}},_vm._l((_vm.users),function(user){return _c('UserItem',{key:((user.id) + "-from-" + (user.searchFrom)),attrs:{"user":user}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }